export enum Position {
  left = 'left',
  right = 'right',
  top = 'top',
  bottom = 'bottom',
  rightTop = 'rightTop',
  leftTop = 'leftTop',
  rightBottom = 'rightBottom',
  leftBottom = 'leftBottom',
  inline = 'inline',
  center = 'center'
}
